<template>
    <section id="home" class="header_area">
      <div class="header_hero">
        <div class="single_hero bg_cover d-flex align-items-center">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8 col-md-10">
                <div class="hero_content text-center">
                  <h2 class="hero_title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Institut Teknologi Del</h2>
                  <p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.5s">MarTuhan - Marroha - Marbisuk</p>
                  <a href="#features" class="main-btn wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.8s">Explore</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <section id="features" class="features_area pt-120">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Landasan Yayasan Del</h4>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-7">
            <div
              class="single_features text-center mt-30 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s">
              <i class="lni lni-shield"></i>
              <h4 class="features_title">MarTuhan</h4>
              <p>percaya kepada Tuhan</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-7">
            <div
              class="single_features text-center mt-30 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s">
              <i class="lni lni-heart"></i>
              <h4 class="features_title">Marroha</h4>
              <p>berhati nurani yang luhur</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-7">
            <div
              class="single_features text-center mt-30 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.6s">
              <i class="lni lni-invention"></i>
              <h4 class="features_title">Marbisuk</h4>
              <p>bijaksana</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <section id="about" class="pt-130">
      <div class="about_area">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="about_content pt-120 pb-130">
                <div class="section_title pb">
                  <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Sejarah IT Del</h4>
                  <p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">Institut Teknologi Del telah berdiri selama 21 tahun. Sejarah IT Del dimulai dari Politeknik Informatika Del yang didirikan pada tahun 2001. Sesuai dengan perkembangan keilmuan dan industri, Politeknik Informatika Del ditingkatkan statusnya menjadi Institut Teknologi Del pada tahun 2013.</p>
                </div>
                <a href="#" class="main-btn wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.7s">Selengkapnya</a>
              </div>
            </div>
          </div>
        </div>
        <div class="about_image bg_cover wow fadeInLeft" data-wow-duration="1.3s" data-wow-delay="0.2s" style="background-image: url(assets/img/about-vision.jpg)">
          <div class="image_content">
            <h4 class="experience"><span>21</span> tahun berdiri</h4>
          </div>
        </div>
      </div>
    </section>
  
    <section id="blog" class="blog_area pt-120">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s"> Del Hari Ini</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="single_blog mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
              <div class="blog_image">
                <router-link to="/artikel"><img src="assets/img/news9.jpg" alt="blog" /></router-link>
              </div>
              <div class="blog_content">
                <h3 class="blog_title"><router-link to="/artikel">Penandatanganan MoU dan PKS antara IT Del dan PT Gramedia</router-link></h3>
                <p>Pada hari Jumat, 30 September 2022 diadakan Penandatanganan Nota Kesepahaman (MoU) dan Perjanjian Kerja Sama tentang Pelayanan Data Statistik, Sharing Knowledge Terkait Data dan Indikator Statistik, Serta Pendirian Pojok Statistik antara Badan Pusat Statistik (BPS)</p>
              </div>
            </div>
          </div>
  
          <div class="col-lg-6">
  
              <div class="card shadow bg-body rounded mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s" style="max-width: 700px;">
                <div class="row g-0">
                    <div class="col-sm-5">
                        <img src="assets/img/news10.jpg" class="card-img-top h-100" alt="Penandatanganan MoU Dan PKS Antara Institut Teknologi Del Dan Badan Pusat Stastik Toba">
                    </div>
                    <div class="col-sm-7">
                        <div class="card-body">
                            <h5 class="card-title">Penandatanganan MoU Dan PKS Antara Institut Teknologi Del Dan Badan Pusat Stastik Toba</h5>
                            <p class="card-text">Pada hari Jumat, 30 September 2022 diadakan Penandatanganan Nota Kesepahaman (MoU) dan Perjanjian Kerja Sama tentang Pelayanan Data Statistik</p>                
                        </div>
                    </div>
                </div>
            </div>
  
              <div class="card shadow bg-body rounded mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s" style="max-width: 700px;">
                <div class="row g-0">
                    <div class="col-sm-5">
                        <img src="assets/img/wisuda.jpg" class="card-img-top h-100" alt="Wisuda Angkatan XIX IT Del">
                    </div>
                    <div class="col-sm-7">
                        <div class="card-body">
                            <h5 class="card-title">Wisuda Angkatan XIX IT Del</h5>
                            <p class="card-text">Pada hari Jumat, 30 September 2022 diadakan Penandatanganan Nota Kesepahaman (MoU) dan Perjanjian Kerja Sama tentang Pelayanan Data Statistik</p>                
                        </div>
                    </div>
                </div>
            </div>
  
            <div class="card shadow bg-body rounded mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s" style="max-width: 700px;">
              <div class="row g-0">
                  <div class="col-sm-5">
                      <img src="assets/img/news8.jpg" class="card-img-top h-100" alt="426 Mahasiswa IT Del Angkatan 2022 Resmi Dikukuhkan">
                  </div>
                  <div class="col-sm-7">
                      <div class="card-body">
                          <h5 class="card-title">426 Mahasiswa IT Del Angkatan 2022 Resmi Dikukuhkan</h5>
                          <p class="card-text">Pada hari Jumat, 30 September 2022 diadakan Penandatanganan Nota Kesepahaman (MoU) dan Perjanjian Kerja Sama tentang Pelayanan Data Statistik</p>                
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <section id="visimisi" class="features_area pt-120">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Visi Misi</h4>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
              <i class="lni lni-briefcase"></i>
              <h4 class="features_title">Visi</h4>
              <p>Menjadi pusat keunggulan yang berperan dalam pemanfaatan teknologi bagi kemajuan bangsa.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6"><div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
              <i class="lni lni-clipboard"></i>
              <h4 class="features_title">Misi</h4>
              <p>
              <ol align="left">
                <li>1. Menyelenggarakan dan mengembangkan proses pendidikan yang unggul, berkesinambungan, dan bermanfaat bagi masyarakat.</li><br>
                <li>2. Mengembangkan, menciptakan dan menyebarkan ilmu pengetahuan dan teknologi.</li><br>
                <li>3. Meningkatkan peran institut agar mampu menjadi pembaharu kemampuan, keterampilan pilihan rujukan dan pengembangan rekayasa karya masyarakat khususnya dalam bidang ilmu pengetahuan dan teknologi.</li><br>
                <li>4. Meningkatkan peran nyata kepada masyarakat melalui penerapan tridharma perguruan tinggi.</li>
              </ol>
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single_features text-center mt-60 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
              <i class="lni lni-target"></i>
              <h4 class="features_title">Tujuan</h4>
              <p>
              <ol align="left">
                <li>1. Menghasilkan tenaga ahli yang berperilaku marTuhan, marRoha, marBisuk yang mempunyai ciri-ciri utama beriman dan bertaqwa kepada Tuhan Yang Maha Esa, bijak, ahli dan terampil dalam bidangnya, berwawasan luas, memiliki sifat kepemimpinan, kesadaran dan tanggung jawab sosial.</li><br>
                <li>2. Menghasilkan karya-karya ilmiah yang memberi dampak mensejahterakan masyarakat.</li><br>
                <li>3. Menghasilkan, mengembangkan dan menyebarluaskan ilmu pengetahuan dan teknologi melalui penyelenggaraan penelitian dan pendidikan tinggi yang berorientasi pendidikan keilmuan dan pengembangan kepribadian.</li><br>
              </ol>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <section id="faculty" class="faculty_area pt-120">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-60">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Pendidikan</h4><p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">IT Del memiliki 4 fakultas dengan 8 program studi</p>
            </div>
          </div>
        </div>
      </div>
  
      <div class="faculty_wrapper d-flex flex-wrap">
        <div class="single_faculty wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
          <img src="assets/img/fite.jpg" alt="faculty" />
          <div class="faculty_content">
            <ul class="meta">
              <li><a href="#"><i class="lni lni-link"></i></a></li>
            </ul>
            <h5 class="faculty_title">Fakultas Informatika dan Elektro</h5>
          </div>
        </div>
  
        <div class="single_faculty wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
          <img src="assets/img/vokasi.jpg" alt="faculty" />
          <div class="faculty_content">
            <ul class="meta">
              <li><a href="#"><i class="lni lni-link"></i></a></li>
            </ul>
            <h5 class="faculty_title">Fakultas Vokasi</h5>
          </div>
        </div>
  
        <div class="single_faculty wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
          <img src="assets/img/gd9.jpg" alt="faculty" />
          <div class="faculty_content">
            <ul class="meta">
              <li><a href="#"><i class="lni lni-link"></i></a></li>
            </ul>
            <h5 class="faculty_title">Fakultas Teknologi Industri</h5>
          </div>
        </div>
  
        <div class="single_faculty wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
          <img src="assets/img/bioteknologi.jpg" alt="faculty" />
          <div class="faculty_content">
            <ul class="meta">
              <li><a href="#"><i class="lni lni-link"></i></a></li>
            </ul>
            <h5 class="faculty_title">Fakultas Bioteknologi</h5>
          </div>
        </div>
      </div>
    </section>
  
    <section id="prestasi" class="prestasi_area pt-120 pb-120">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Prestasi</h4>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_prestasi text-center mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
              <span class="price">12 Ha</span>
              <h4 class="prestasi_title">Luas Kampus</h4>
              <a href="#" class="mian-btn">Lihat Peta</a>
            </div>
          </div>
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_prestasi text-center mt-30 active wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
              <span class="price">Top 6</span>
              <p class="text-white">PTN/PTS Se-Sumatera Utara</p>
              <a href="https://www.del.ac.id/?p=12166" class="mian-btn">Data Selengkapnya</a>
            </div>
          </div>
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_prestasi text-center mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
              <span class="price">80%</span>
              <h4 class="prestasi_title">Lulusan Langsung Bekerja</h4>
              <a href="#" class="mian-btn">Daftar Alumni</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  
    <section id="dosen" class="dosen_area pt-120 pb-130">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">Dosen</h4>
              <p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">Institut Teknologi Del selalu berupaya menciptakan lingkungan pendidikan yang sehat dengan dukungan tenaga pengajar yang ahli dan profesional.</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center dosen_active">
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_dosen mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
              <img src="assets/img/dosen2.jpg" alt="dosen" />
              <div class="dosen_content">
                <h4 class="dosen_name"><a href="#">Monalisa Pasaribu, SS., M.Ed (TESOL)</a></h4>
                <p>Fakultas Vokasi</p>
                <ul class="social">
                  <li><a href="#"><i class="lni lni-facebook-filled"></i></a></li>
                  <li><a href="#"><i class="lni lni-twitter-original"></i></a></li>
                  <li><a href="#"><i class="lni lni-linkedin-original"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_dosen mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
              <img src="assets/img/dosen1.jpg" alt="ASD" />
              <div class="dosen_content">
                <h4 class="dosen_name"><a href="#">Arie Satia Dharma, S.T, M.Kom</a></h4>
                <p>Fakultas Informatika dan Elektro</p>
                <ul class="social">
                  <li>
                    <a href="#"><i class="lni lni-facebook-filled"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni lni-twitter-original"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni lni-linkedin-original"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-8 col-sm-10">
            <div class="single_dosen mt-30 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
              <img src="assets/img/dosen3.jpg" alt="dosen" />
              <div class="dosen_content">
                <h4 class="dosen_name"><a href="#">Dr. Yosef Barita Sar Manik, S.T, M.Sc.</a></h4>
                <p>Fakultas Teknologi Industri</p>
                <ul class="social">
                  <li>
                    <a href="#"><i class="lni lni-facebook-filled"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni lni-twitter-original"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="lni lni-linkedin-original"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section_title text-center mt-70">
        <router-link to="/dataDosen" class="main-btn wow fadeInUp align-self-center mx-auto" data-wow-duration="1.0s" data-wow-delay="0.5s">Lihat Daftar Dosen</router-link>
      </div>
    </section>
  
  <section id="alumni" class="alumni_area pt-130 pb-130 bg_cover" style="background-image: url(assets/img/lbp_cop.jpeg)">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="glide alumni_active">
            <div class="glide__track" data-glide-el="track">
              <div class="glide__slides">
                <div class="glide__slide single_alumni text-center">
                  <img src="assets/img/alumni1.jpg" alt="author">
                  <h5 class="author_name">Natanael Siregar</h5>
                  <span>Software Engineer at Google</span>
                  <p>Kuliah di IT Del cukup melelahkan, namun semua akan indah pada waktunya.</p>
                </div>
                <div class="glide__slide single_alumni text-center">
                  <img src="assets/img/alumni2.jpeg" alt="author">
                  <h5 class="author_name">Roosen Manurung</h5>
                  <span>Fullstack Developer at Amazon</span>
                  <p>Your loyalty to your captors is touching.</p>
                </div>
                <div class="glide__slide single_alumni text-center">
                  <img src="assets/img/alumni3.jpg" alt="author">
                  <h5 class="author_name">Yoel Napitupulu</h5>
                  <span>Senior Developer at IBM</span>
                  <p>Don't Look Back In Anger</p>
                </div>
                <div class="glide__slide single_alumni text-center">
                  <img src="assets/img/alumni4.jpeg" alt="author">
                  <h5 class="author_name">Vistar Rajagukguk</h5>
                  <span>Software Tester at Gojek</span>
                  <p>Saya beruntung bisa kuliah di IT Del.</p>
                </div>
                <div class="glide__slide single_alumni text-center">
                  <img src="assets/img/alumni5.jpeg" alt="author">
                  <h5 class="author_name">Nanchy Siadari</h5>
                  <span>UI/UX Designer at Unilever</span>
                  <p>Tidak ada waktu bermain di IT Del, pandailah dalam manajemen waktu.</p>
                </div>              
              </div>
            </div>
  
            <div class="glide__bullets" data-glide-el="controls[nav]">
              <button class="glide__bullet" data-glide-dir="=0"></button>
              <button class="glide__bullet" data-glide-dir="=1"></button>
              <button class="glide__bullet" data-glide-dir="=2"></button>
              <button class="glide__bullet" data-glide-dir="=3"></button>
              <button class="glide__bullet" data-glide-dir="=4"></button>
            </div>
          </div>
        </div>
      </div> 
    </div> 
    </section>
  
    <section id="contact" class="contact_area bg_cover pt-120 pb-130" style="background-image: url(assets/img/3.jpg)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section_title section_title_2 text-center pb-25">
              <h4 class="title wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s" id="hubungikami">Hubungi Kami</h4>
              <p class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s"> Jika anda memiliki pertanyaan ataupun saran, silakan isi form dibawah ini.
              </p>
            </div>
          </div>
        </div>
        <form id="contact-form" class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s">
          <div class="row">
            <div class="col-lg-6">
              <div class="single_form">
                <input type="text" placeholder="Nama" name="name" id="name" required />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single_form">
                <input type="email" placeholder="Email" name="email" id="email" required />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single_form">
                <input type="text" placeholder="Nomor handphone" name="number" id="number" required />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="single_form">
                <input type="text" placeholder="Judul" name="subject" id="subject" required />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="single_form">
                <textarea placeholder="Pesan anda" name="message" id="message" required></textarea></div>
            </div>
            
            <p class="form-message"></p>
            <div class="col-lg-12">
              <div class="single_form text-center">
                <button class="main-btn" type="button">Kirim</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </template>